import React from 'react';

function AccCreateByVendorPage() {
    return <div>AccCreateVendorPage</div>;
}

export default AccCreateByVendorPage;
